
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface EmailVerificationScreenProps {
  email: string;
  onRetry: () => void;
}

const EmailVerificationScreen = ({ email, onRetry }: EmailVerificationScreenProps) => {
  const navigate = useNavigate();

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl font-bold text-center">Check your email</CardTitle>
        <CardDescription className="text-center">
          We've sent a verification link to {email}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-center text-gray-600">
            Click the link in your email to verify your account.
          </p>
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              If you don't see the email, check your spam folder or try again.
            </AlertDescription>
          </Alert>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col space-y-2">
        <Button 
          onClick={() => navigate('/login')}
          variant="outline" 
          className="w-full"
        >
          Go to login
        </Button>
        <div className="text-center text-sm">
          Didn't receive the email?{' '}
          <Button 
            variant="link" 
            className="p-0 h-auto font-medium text-ai-indigo hover:text-ai-purple"
            onClick={onRetry}
          >
            Try again
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

export default EmailVerificationScreen;
